import axios from "../http-config/axiosConfig";

const EndpointsApi = {
	getAllEndpointsAsync: async () => {
		const { data } = await axios.get("/Admin/Endpoints");
		return data.result;
	},

	updateEndpointsAsync: async (updatedEndpoints) => {
		const { data } = await axios.put("/Admin/Endpoints", updatedEndpoints);
		if (!data.isSuccess) {
			throw Error(data.message);
		}
		return data.result;
	},

	testEndpointsAsync: async () => {
		const { data } = await axios.get("/ComCourt/TestLawbase");
		return data;
	},
};

export default EndpointsApi;
